import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { Children, FunctionComponent, ReactElement } from "react";

const StyledBox = styled(Box)(({
	theme,
}) => ({
	"& > :not(:first-child)": {
		marginLeft: 0,
		width: "auto",
	},
}));

export interface FormFieldRowProps extends BoxProps {

};

const FormFieldRow: FunctionComponent<FormFieldRowProps> = (props) => {
	const { children, ...otherProps } = props;

	const childArray = Children.toArray(children)
		.map((Child, i) => {
			return React.cloneElement(Child as ReactElement, { notFirst: i != 0, multipleInline: true });
		});

	return (
		<StyledBox children={childArray} {...otherProps} />
	);
};

export default FormFieldRow;